import { ApiOtherYouMayLikeResponse } from '../../domain/models/api-other-you-may-like.model';
import { ProductUid } from '../../domain/models/related-products.models';

export const otherYouMayLikeTransformer = (response: ApiOtherYouMayLikeResponse): ProductUid[] => {
    const output = response.outputs.find((_output) => _output.name === 'part_numbers');

    return output.data.reduce((acc, reference) => {
        const mcc = reference.split('-')[0];
        acc.push({
            colorId: mcc.slice(-3),
            modelName: response.model_name,
            modelVersion: response.model_version,
            product_id: null,
            provider: 'YODA',
            relatedType: 'other_you_may_like',
            uid: mcc.slice(0, -3),
        });
        return acc;
    }, []);
};
